import { render, staticRenderFns } from "./editor-section-modal.vue?vue&type=template&id=4ef7ac23&scoped=true"
import script from "./editor-section-modal.vue?vue&type=script&lang=ts"
export * from "./editor-section-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef7ac23",
  null
  
)

export default component.exports